var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.35ae3891dcd41810ce0c42e28e880812.svg#v';
                    var viewUrl = 'sprites.35ae3891dcd41810ce0c42e28e880812.svg#view-v';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 10 11',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };